import TAP1 from '@/assets/tap1.jpg';
import TAP2 from '@/assets/tap2.jpg';
import TAP3 from '@/assets/tap3.jpg';

export const CARD_STYLES = {
  tap1: {
    img: TAP1,
    subtitleBg: 'bg-[#ffe3e7]',
    textAndCupColor: 'text-[#cc2940]',
    cupBg: 'bg-[#F2F2F2]',
    buttonColor: 'bg-[#cc2940]',
    hashColor: 'text-[#cc2940]',
  },
  tap2: {
    img: TAP3,
    subtitleBg: 'bg-[#ffefdf]',
    textAndCupColor: 'text-[#f28c28]',
    cupBg: 'bg-[#F2F2F2]',
    buttonColor: 'bg-[#f28c28]',
    hashColor: 'text-[#f28c28]',
  },
  tap3: {
    img: TAP2,
    subtitleBg: 'bg-[#ebffe1]',
    textAndCupColor: 'text-[#78ba28]',
    cupBg: 'bg-[#F2F2F2]',
    buttonColor: 'bg-[#78ba28]',
    hashColor: 'text-[#8dff2a]',
  },
};
